module.exports = __webpack_public_path__ + "img/Circle_Info.6856c429.svg";